<template>

  <div class="breadBox">
    <a-breadcrumb>
      <span>
        <img src="@/assets/img/position.png"/>
        当前位置：
      </span>
      <a-breadcrumb-item style="cursor: pointer;" @click="goMore('/finance/index','首页')">首页</a-breadcrumb-item>
      <a-breadcrumb-item style="cursor: pointer;" @click="goMore('/finance/institution/index','金融机构')">金融机构</a-breadcrumb-item>
      <a-breadcrumb-item v-if="optionsData">{{optionsData.name}}</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
  <div class="cont_body" v-if="optionsData">
    <div class="list_cont">
      <div class="list_img">
        <img v-if="optionsData.logo" :src="getImg(optionsData.logo)" alt="">
        <img v-else src="@/assets/img/defaultPhoto.png" alt="">
      </div>
      <div class="list_cont_body">
        <h4>{{optionsData.name}}</h4>
        <div class="list_cont_mid">
          <!-- <p><span v-for="(item,key) in optionsData.investmentField.split()" :key="key">
            <dict-render :dict-obj="dictObjs['investmentField']"
          :text="item"></dict-render>
          </span>
            </p> -->
            <p>
              联系电话：{{optionsData.telephone}}
            </p>
        </div>
      </div>
      <!-- <div class="list_botton">
        <a-button size="large"  v-if="role=='company'" @click="onAdd" style="width:120px;" >投递BP</a-button>
        <a-button size="large"  v-else style="width:120px;background: #b3b3b3;" >投递BP</a-button>
      </div> -->
    </div>
    <div class="list_bottom">
      <h4>金融机构简介</h4>
      <p v-html="optionsData.briefIntroduction">

      </p>
    </div>
  </div>
  <a-modal width="700px" title="投递BP" v-model:visible="visible" :maskClosable="false" :closable="false"  @ok="onSubmit" @cancel="handleCancel">
    <a-form :labelCol="{span:6}" layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
      <a-row :gutter="[24,8]">
        <a-col :span="24">
            <div class="hidden">
                <a-form-item label="当前id" name="senderId">
                    <a-input v-model:value="form.senderId" placeholder="请输入当前id" />
                </a-form-item>
                <a-form-item label="本条id" name="receiverId">
                    <a-input v-model:value="form.receiverId" placeholder="请输入本条id" />
                </a-form-item>
                <a-form-item label="对接类型" name="dockingType">
                    <a-input v-model:value="form.dockingType" placeholder="类型" />
                </a-form-item>
            </div>
            <a-form-item :labelCol='{span:4}' v-if="role=='company'" label="项目名称" name="projectId">
              <single-select
                  v-model:value="form.projectId"
                  :options="lists"
                  titleName="value"
                  valueName="id"
              />
            </a-form-item>
            <a-form-item :labelCol='{span:6}' style="margin-left:-68px" v-if="InvestorManagerOption[0]" label="金融机构联系人" name="investorManagerId">
              <single-select
                  v-model:value="form.investorManagerId"
                  :options="InvestorManagerOption"
                  titleName="value"
                  valueName="id"
              />
            </a-form-item>
            <a-form-item :labelCol='{span:4}' label="联系人姓名" name="senderContact">
                <a-input v-model:value="form.senderContact" placeholder="请输入联系人姓名" />
            </a-form-item>
            <a-form-item :labelCol='{span:4}' label="联系人电话" name="senderContactNumber">
                <a-input v-model:value="form.senderContactNumber" placeholder="请输入联系人电话" />
            </a-form-item>
            <a-form-item :labelCol='{span:4}' label="对接备注" name="notes">
                <a-textarea v-model:value="form.notes" placeholder="请输入对接备注"
                          :auto-size="{ minRows: 5, maxRows: 6 }" />
            </a-form-item>
        </a-col>
      </a-row>
  </a-form>
</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {
  // dictMixin,
  formMixin } from "@/mixins";
import {financeInstitutionWeb,financeDocking,financeProject,financeInvestorManager} from "@/api/finance";
import {file_service} from "@/api/adminService";
// import DictRender from "@/components/other/DictRender";
export default {
  name: 'investor',
  components: {
    // DictRender
   },
  mixins: [formMixin
  // ,dictMixin
],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dictNames: 'investmentField',
      optionsData:null,
      lists: [],
      InvestorManagerOption: [],
      visible:false,
      role: null,
      form: {
          projectId: null,
          senderId: null,
          investorManagerId: null,
          receiverId: null,
          dockingType: 3,
          senderContact: null,
          senderContactNumber: null,
          notes: null,
          processingState: null,
      },
      rules: {
          projectId: [dataCheck.required({})],
          senderId: [],
          dockingType: [],
          investorManagerId: [],
          receiverId: [],
          senderContact: [dataCheck.required({})],
          senderContactNumber: [dataCheck.required({}),dataCheck.phone],
          processingState: [dataCheck.required({})],
          notes: [],
      },
    }
  },
  computed: {
      submitUrl() {
          return financeDocking.add
      }
  },
  created(){
    if(this.$route.query.queryData){
      this.getAction({
          url: financeInstitutionWeb.detail,
          params: {
            id:this.$route.query.queryData
          }
      }).then(res => {
        this.optionsData = res
        this.form.receiverId = res.userId
        this.form.senderId = this.$ls.get('notificationId')
        this.role = this.$ls.get('roleCode').replace("[","").replace("]","").replace("\"","").replace("\"","").replace("\"","").replace("\"","").split(',')
        this.role.map( item => {
          if(item=='company'){
          this.role = item
          }
        })

      })
    }
  },
	methods: {
    getInvestorManager(){
      this.getAction({
          url: financeInvestorManager.list,
          params: {
            mechanismId:this.$route.query.queryData,
          }
      }).then(res => {
        // this.InvestorManagerOption = res
        res.map(item => {
          this.InvestorManagerOption.push({id:item.id,value:item.name})
        } )
      })
    },
    getProject() {
      this.getAction({
          url: financeProject.list,
          params: {
            id:this.$ls.get('companyCode'),
            dockingType: 3
          }
      }).then(res => {
        res.map(item => {
          this.lists.push({id:item.id,value:item.projectName})
        } )
      })
    },
    onAdd() {
            if(this.$ls.get('token')){
              this.visible=true;
              this.form.senderContact=null,
              this.form.senderContactNumber=null,
              this.form.notes=null,
              this.getInvestorManager()
              this.getProject()
            }else{
                    this.$notification.warning({
                                message: '登录后可以操作',
                                style: {
                                    fontWeight: '600',
                                },
                            });
              this.$router.push({ path: '/login', query: { id: 'user' } })
            }
    },
    handleOk(){
            this.visible = false;
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },

		goMore(url,key) {
      this.$router.push({
				path: url,
				query: { type: key }
			})
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.list_cont{
  width: 100%;
  margin-bottom: 16px;
  &:hover{
    cursor: auto!important;
    box-shadow: none!important;
  }
  .list_img{
    width: 100px;
    height: 100px;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px;
    display: flex;
    align-items: center;
    img{
      width: 100%;
    }
  }
  .list_cont_body{
    height:130px;
    flex: 6;
    h4{
      line-height: 50px;
    }
    .list_cont_mid{
      overflow: auto;
      padding-right:30%;
      color:#9c9c9c;
      p{
        display: block;
        float: left;
        width: 50%;
      }
    }
    .list_cont_end{
      margin-top: 20px;
      clear: both;
    }
  }
  .list_botton{
    flex: 1;
    :deep(.ant-btn){
      font-size: 14px;
      background: #1890ff;
      color:#fff;
      border:none
    }
  }
}
.list_bottom{
  h4{
    color:#1890ff;
    font-weight: 600;
    font-size: 22px;
    margin-bottom: 10px;
  }
  p{
    line-height: 25px;
  }
}
</style>
